// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)
import MediaFormatOptionsController from "./media_format_options_controller"
application.register("media-format-options", MediaFormatOptionsController)
import SlugifyController from "./slugify_controller"
application.register("slugify", SlugifyController)
import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
